module.exports = __webpack_public_path__ + "img/check.7e5e1e52.svg";